/*
 *  Copyright (c) 2021.
 *  This file is part of the Compo B2B application.
 *  (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 *  For the full copyright and license information, please view the LICENSE
 *  file that was distributed with this source code.
 */

import {AfterContentInit, Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {TreeItem} from './tree-item';
import { NgTemplateOutlet } from "@angular/common";

@Component({
    selector: 'app-compo-tree',
    templateUrl: './compo-tree.component.html',
    imports: [
    NgTemplateOutlet
],
    styleUrls: ['./compo-tree.component.css']
})
export class CompoTreeComponent<T extends TreeItem> implements OnInit, AfterContentInit {
  @Input()
  public treeData: T[] = [];

  @ContentChild(TemplateRef)
  public nodeTemplate: TemplateRef<any> | null = null;

  ngOnInit() {
    console.log('compo-tree');
  }

  public ngAfterContentInit(): void {
    if (!this.nodeTemplate) {
      throw new Error('This component needs ng-template for the tree node.');
    }
  }
}
